<app-group-section-base
  [templateRef]="additionalIncomeGroupVat"
  [isActive]="isMainStepActive"
  [statementFullYear]="additionalIncomeService.mainStatement?.fullYear"
  [selectedCounter]="selectedCounter"
  [selectButtons]="selectButtons"
  [title]="groupTitle"
  [description]="description"
  [titleTooltip]="'' | translate"
  [messageTooltip]="'' | translate"
>
</app-group-section-base>

<ng-template #additionalIncomeGroupVat>
  @if (subSteps) {
    @if (isSubStepActive(VatDeclarationSubSteps?.VAT_DECLARATION)) {
      <app-group-section-edit-single-base
        [templateRef]="vatDeclaration"
        [overTitle]=""
        [title]="groupTitle"
        [description]="''"
        [titleTooltip]="'' | translate"
        [messageTooltip]="'' | translate"
      >
      </app-group-section-edit-single-base>
    }
  }
</ng-template>

<ng-template #vatDeclaration>
  <app-form-list
    [itemTitle]=""
    [formTemplateRef]="vatinputs"
    [list]="vatDeclarationManager.getVatDeclaration(additionalIncomeService.currentStatement)"
    [isAddButtonEnabled]="false"
    [isRemoveButtonEnabled]="false"
    (removeButtonClickEmitter)="vatDeclarationManager.removeVatDeclaration(additionalIncomeService.currentStatement)"
    (addButtonClickEmitter)="vatDeclarationManager.createVatDeclaration(additionalIncomeService.currentStatement)"
  ></app-form-list>
</ng-template>

<ng-template #vatinputs let-item="item" let-index="index">
  <app-additional-income-form-vat
    [vatDeclaration]="item"
    [index]="index"
    [statement]="additionalIncomeService.currentStatement"
    [isBusiness]="isBusiness"
  ></app-additional-income-form-vat>
</ng-template>
